export const pick = () =>
  Promise.resolve([{ uri: 'mocked-uri', name: 'mocked-file.pdf', type: 'application/pdf' }])

export const keepLocalCopy = () => Promise.resolve(true)

export const types = {
  pdf: 'anything',
  doc: 'anything',
  docx: 'anything',
}

export const isErrorWithCode = () => false

export const errorCodes = { OPERATION_CANCELED: 'cancelled' }
